import TextInput from "../../../components/Comon/TextInput/TextInput";
import Button from "../../../components/Comon/Button/Button";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {validateWellnessRegisterData} from "../../../../core/axios/services";
import CheckboxThemed from "../../../components/Comon/CheckboxThemed";

export default function WellnessSurveyRegisterScreen({
                                                         formData,
                                                         setFormData = () => {},
                                                         handleRegisterNext = () => {},
                                                         errorsData,
                                                         settingsData,
                                                         clinicData,
                                                         themeColor,

                                                     })
{
    const { i18n } = useTranslation();
    const [isCheckedClinic, setIsCheckedClinic] = useState(false);




    return <div style={{
        maxWidth:'700px',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column'
    }}>
        {/*<div className={"helloDiv"} style={{ borderColor: themeColor }}>{'Section Title'}</div>*/}
        <div className={"headline"}>{settingsData?.registerTitle}</div>

        <div className={"heroForm"}>
            <TextInput
                mode={"grey"}
                type={"text"}
                value={formData?.name}
                setValue={(value) => setFormData({...formData, name:value})}
                errorMessage={errorsData?.name}
                label={i18n.t("firstName")}
                placeholder={i18n.t("typeHere")}
            />
            <TextInput
                mode={"grey"}
                type={"text"}
                value={formData?.lastName}
                setValue={(value) => setFormData({...formData, lastName:value})}
                errorMessage={errorsData?.lastName}
                label={i18n.t("lastName")}
                placeholder={i18n.t("typeHere")}
            />
            <TextInput
                mode={"grey"}
                type={"text"}
                value={formData?.email}
                setValue={(value) => setFormData({...formData, email:value})}
                errorMessage={errorsData?.email}
                label={i18n.t("emailAddress")}
                placeholder={i18n.t("typeHere")}
            />
            <p className="privacyTerms surveyPolicy">
                {i18n.t("termsPrivacy")}
                <br /> {i18n.t("tothe")}{" "}
                <a href="http://chiropracticoutcomes.com/privacy" target="_blank">
                    {i18n.t("privacypolicy")}
                </a>{" "}
                {i18n.t("and")} <a href="http://chiropracticoutcomes.com/terms">{i18n.t("terms")}</a>
            </p>


            <label style={{ marginTop: "15px" }}>

                <p className="privacyTerms surveyPolicy" style={{marginBottom:'15px'}}>
                    {i18n.t("termsIntro")}
                </p>

                <p className="privacyTerms surveyPolicy" style={{cursor:'pointer', display:'flex', justifyContent:'flex-start', alignItems:'flex-start' }}>
                    <div
                        onClick={() => setIsCheckedClinic(!isCheckedClinic)}
                        style={{marginTop:'2px'}}
                    >
                        <CheckboxThemed
                            size={16}
                            themeColor={themeColor}
                            isChecked={isCheckedClinic}
                        />
                    </div>


                    <div>
                        {i18n.t("termsInfo")} {" "}
                        <a href={settingsData?.clinicTermsUrl} target="_blank" style={{color:"#61849d",textDecoration:'underline'}}>
                            Data Processing Information
                        </a>{i18n.t("termsInfo2")}
                    </div>
                </p>
            </label>
        </div>

        <div
            style={{ display:'flex', justifyContent:'center',alignItems:'center'}}
        >
            <div className={"presentContainer"} onClick={() => handleRegisterNext()}>
                <Button
                    color={themeColor}
                    mode={"small"}
                    text={i18n.t("startSurvey")}
                    disabled={!isCheckedClinic || !formData?.name || !formData?.lastName || !formData?.email}

                />
            </div>
        </div>
    </div>
}
